import React from "react";
import moment from "moment";
import { component_tool } from '@/tool'

let { WizDataTable, WizButton } = component_tool

//配置项
const componentName = "audience";

function columns() {
  return [
    {
      name: "id",
    },
    {
      title: "场景类型",
      name: "sceneTypeId",
      searchItem: {
        type: 'select'
      },
      tableItem: {},
      dict: [
        { code: 0, codeName: '课程' },
        { code: 1, codeName: '考试' },
        { code: 2, codeName: '问卷' },
        { code: 3, codeName: '直播' },
        { code: 4, codeName: '考试模版组' },
        { code: 5, codeName: '考试分类' },
        { code: 6, codeName: '题目分类' },
        { code: 7, codeName: '课件' },
        { code: 8, codeName: '线下课程' },
        { code: 9, codeName: '培训中心' },
        { code: 10, codeName: '教室' },
        { code: 12, codeName: '路径必修' },
        { code: 13, codeName: '路径选修' },
        { code: 14, codeName: '审核' },
        { code: 16, codeName: '评语' },
        { code: 36, codeName: '班级管理' },
        { code: 25, codeName: '系列化课程' },
        { code: 20, codeName: '内容管理' },
        { code: 21, codeName: '证书管理' },
        { code: 23, codeName: '活动' },
        { code: 28, codeName: '规则' },
        { code: 32, codeName: '路径阶段' },
        { code: 33, codeName: '路径任务' },
        { code: 27, codeName: '推荐' },
        { code: 125, codeName: '使用' },
      ]
    },
    {
      title: "场景名称",
      name: "sceneName",
      searchItem: {},
      tableItem: {},
    },
    {
      title: "状态",
      name: "delFlag",
      searchItem: {
        type: 'select',
        initialValue: 0
      },
      dict: [
        {
          code: 0,
          codeName: '使用中'
        },
        {
          code: 1,
          codeName: '作废'
        }
      ]
    },
    {
      title: "创建时间",
      name: "createTime",
      searchItem: {
        type: 'date~'
      },
    },
    {
      title: "创建时间",
      name: "createTime",
      tableItem: {
        width: 200,
        render: (text) => moment(text).format('YYYY-MM-DD HH:mm')
      },
    },
    {
      title: "受众",
      name: "groupScope",
      tableItem: {
        render: (text) => (
          <WizDataTable.Oper>
            <WizButton onClick={() => this.handleLook(text)}>查看受众</WizButton>
          </WizDataTable.Oper>
        )
      },
    },
    {
      title: "状态",
      name: "delFlag",
      tableItem: {},
      dict: [
        {
          code: 0,
          codeName: '使用中'
        },
        {
          code: 1,
          codeName: '作废'
        }
      ]
    },
  ];
}

function templateConfig() {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns.call(this),
        searchBarProps: {
          dataFormat: (val) => {
            let { createTime } = val
            if (createTime && createTime.length) {
              if (createTime[0]) {
                val['startDate'] = moment(createTime[0]).format("YYYY-MM-DD 00:00:00")
              }
              if (createTime[1]) {
                val['endDate'] = moment(createTime[1]).format("YYYY-MM-DD 23:59:59")
              }
            } else {
              val['startDate'] = ''
              val['endDate'] = ''
            }
            return val
          },
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          isScroll: true,
          loading: false,
          bordered: true,
        },
      },
    },
  };
}

const apis = (bizType, bizId, validBiz) => {
  return {
    list: {
      path: `${componentName}/listByPage`,
      payload: {
        key: `${componentName}@listByPage`,
        apiParams: { current: 1, pageSize: 10, delFlag: 0, bizType, bizId, validBiz },
      },
    },
  }

};

let reduxTemplateCofig = (args) => {
  let { bizType, bizId, validBiz } = args
  return {
    apis: apis(bizType, bizId, validBiz),
    componentName,
    initApiKeys: ["list"],
    needLoading: true,
    keepInitApiParams: true,
    ...args,
  };
};

export { reduxTemplateCofig, templateConfig };
